/* Manu AI v27 (23/10/2026) — le message de Manu ne disparaît plus quand l'écran de contrôle arrive.
 * - Ordinateur (≥ 900 px) : chat à gauche, écran de contrôle (mockup, validation, vêtement…) à droite, côte à côte, en permanence.
 * - Mobile : l'écran prend la place ; le dernier message de Manu reste affiché en bandeau animé sur le mockup, puis s'efface (ou au premier geste).
 *   Si Manu pose une question ou bloque (plus de création offerte), l'écran bascule sur le chat (v26).
 * Les écrans existants (v13 → v26) ne changent pas. Le chat reste le même élément (fil, pastilles, champ) : seul son emplacement change.
 * S'appuie sur section._ais enrichie par v9 → v26 (setView / hasStage : v18). */
(function () {
  'use strict';

  var TXT = {
    fr: { close: 'Fermer le message', manu: 'Message de Manu' },
    en: { close: 'Close the message', manu: 'Message from Manu' },
    es: { close: 'Cerrar el mensaje', manu: 'Mensaje de Manu' },
    de: { close: 'Nachricht schließen', manu: 'Nachricht von Manu' },
    it: { close: 'Chiudi il messaggio', manu: 'Messaggio di Manu' }
  };
  var X = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function enhance(root) {
    var inst = root._ais;
    if (!inst || inst._v27 || !inst._v26 || !inst._v24 || !inst._v18) return;
    var dlg = inst.dialog, thread = inst.thread, shell = thread && thread.parentNode, dock = shell && shell.querySelector('.ais-dock');
    if (!dlg || !thread || !dock) return;
    inst._v27 = true;
    dlg.setAttribute('data-v27', '');
    var DESK = window.matchMedia('(min-width: 900px)');
    function tx() { return TXT[inst.loc] || TXT.fr; }
    function reduced() { return !!inst.reduce || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }

    /* ---------- Coque : [ chat | écran ] — le fil et le champ de saisie sont déplacés tels quels ---------- */
    var body = document.createElement('div'); body.className = 'ais27-body';
    var chat = document.createElement('div'); chat.className = 'ais27-chat';
    shell.insertBefore(body, thread);
    body.appendChild(chat);
    Array.prototype.slice.call(shell.querySelectorAll('.ais24-ret')).forEach(function (n) { chat.appendChild(n); });
    chat.appendChild(thread); chat.appendChild(dock);

    /* ---------- Écran présent ? Sur ordinateur le chat garde toujours la main côté logique (v18 : view = 'chat') ---------- */
    var has = false, fixing = false;
    function sync() {
      var h = !!(inst.hasStage && inst.hasStage());
      has = h;
      if (h) dlg.setAttribute('data-v27-stage', ''); else dlg.removeAttribute('data-v27-stage');
    }
    function enforce() {
      if (DESK.matches && dlg.getAttribute('data-view') === 'stage') { fixing = true; inst.setView('chat'); fixing = false; inst.scroll(); }
    }
    new MutationObserver(function () { if (fixing) return; sync(); enforce(); }).observe(dlg, { attributes: true, attributeFilter: ['data-view'] });
    function onMQ() { sync(); if (DESK.matches) enforce(); else if (has && inst.setView) inst.setView('stage'); }
    if (DESK.addEventListener) DESK.addEventListener('change', onMQ); else if (DESK.addListener) DESK.addListener(onMQ);
    var baseReset = inst.reset;
    inst.reset = function () { var r = baseReset.apply(this, arguments); sync(); return r; };

    /* ---------- Mobile : le dernier message de Manu reste lisible sur l'écran qui arrive ---------- */
    var last = '', fresh = false, noteEl = null, noteTimer = 0;
    var baseBot = inst.bot;
    inst.bot = function () {
      var p = baseBot.apply(this, arguments);
      if (p && p.then) p.then(function (d) { if (d && d.textContent) { last = String(d.textContent).trim(); fresh = !!last; } }, function () {});
      return p;
    };
    function dropNote(now) {
      clearTimeout(noteTimer);
      var n = noteEl; noteEl = null; if (!n) return;
      if (now || reduced() || !n.animate) { n.remove(); return; }
      var a = n.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(-8px)' }], { duration: 260, easing: 'cubic-bezier(.16, 1, .3, 1)', fill: 'forwards' });
      a.onfinish = function () { n.remove(); };
    }
    function showNote() {
      if (DESK.matches || !fresh || !last) return;
      var host = dlg.querySelector('.ais-v18__pane:not(.is-out) .ais24__stage');
      if (!host) return;
      fresh = false; dropNote(true);
      var n = document.createElement('div'); n.className = 'ais27-note'; n.setAttribute('role', 'status');
      n.innerHTML = '<p class="ais27-note__t"><span class="ais-vh">' + esc(tx().manu) + ' : </span>' + esc(last) + '</p><button type="button" class="ais27-note__x" aria-label="' + esc(tx().close) + '">' + X + '</button>';
      n.querySelector('button').addEventListener('click', function () { dropNote(); });
      host.appendChild(n); noteEl = n;
      if (!reduced() && n.animate) n.animate([{ opacity: 0, transform: 'translateY(-10px)' }, { opacity: 1, transform: 'none' }], { duration: 380, easing: 'cubic-bezier(.16, 1, .3, 1)' });
      noteTimer = setTimeout(function () { dropNote(); }, Math.min(9000, 3500 + last.length * 35));   // le temps de lire
      var first = function () { host.removeEventListener('pointerdown', first, true); setTimeout(function () { dropNote(); }, 400); };   // un geste sur le mockup = l'écran prend le focus
      host.addEventListener('pointerdown', first, true);
    }
    var baseShow = inst.showResult;
    inst.showResult = function () { var r = baseShow.apply(this, arguments); sync(); setTimeout(showNote, 0); return r; };
    var baseStage = inst.stageShow;
    if (baseStage) inst.stageShow = function () { var r = baseStage.apply(this, arguments); sync(); setTimeout(showNote, 0); return r; };
    // L'écran est refait (changement de face, retouche…) : le bandeau, lui, est vu : on l'enlève
    var baseRender = inst.renderResult;
    inst.renderResult = function () { if (noteEl && !noteEl.isConnected) noteEl = null; return baseRender.apply(this, arguments); };
    dlg.addEventListener('close', function () { dropNote(true); });
    sync();

    /* ---------- Image d'inspiration : Manu ne demande plus devant / dos / les deux (devant + dos par défaut, réglé ensuite sur le mockup) ---------- */
    var baseAsk = inst.askManu;
    inst.askManu = function () {
      var s = this.s; if (s && s.inspire && !s.sides) s.sides = 'both';
      return baseAsk.apply(this, arguments);
    };
  }

  function boot(n) {
    n = typeof n === 'number' ? n : 0;
    document.querySelectorAll('[data-ais]').forEach(function (root) {
      var i = root._ais;
      if (i && i._v26 && i._v24 && i._v18) enhance(root);
      else if (n < 40) setTimeout(function () { boot(n + 1); }, 150);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(0); }); else boot(0);
  document.addEventListener('shopify:section:load', function () { setTimeout(function () { boot(0); }, 10); });
})();
